// URL-based language for public SEO pages: Ukrainian at /x, Russian at /ru/x.
// Keep LOCALIZED_PATTERNS in sync with LOCALIZED_ROUTES in scripts/prerender.js.

export const SITE_URL = 'https://kh-tools.com';

const LOCALIZED_PATTERNS = [/^\/$/, /^\/rent\/[^/]+$/, /^\/how-it-works$/, /^\/about$/, /^\/business$/];

// "/about/" → "/about" (Apache 301s these, but don't rely on it client-side)
function normalize(path) {
  if (!path) return '/';
  return path.length > 1 && path.endsWith('/') ? path.replace(/\/+$/, '') || '/' : path;
}

export function getLangFromPath(path) {
  const p = normalize(path);
  return p === '/ru' || p.startsWith('/ru/') ? 'ru' : 'uk';
}

export function stripLang(path) {
  const p = normalize(path);
  if (p === '/ru') return '/';
  return p.startsWith('/ru/') ? p.slice(3) : p;
}

export function isLocalizablePath(path) {
  const base = stripLang(path);
  return LOCALIZED_PATTERNS.some((re) => re.test(base));
}

// Returns the path for `lang`; pages without a Russian version stay on their single URL.
export function localizedPath(path, lang) {
  const base = stripLang(path);
  if (lang !== 'ru' || !isLocalizablePath(base)) return base;
  return base === '/' ? '/ru' : `/ru${base}`;
}

export function absoluteUrl(path) {
  return path === '/' ? SITE_URL : `${SITE_URL}${path}`;
}

// { uk, ru } absolute URLs for hreflang alternates
export function alternateUrls(path) {
  return {
    uk: absoluteUrl(localizedPath(path, 'uk')),
    ru: absoluteUrl(localizedPath(path, 'ru')),
  };
}
